import * as React from 'react'
import * as Urql from 'urql'
import PropTypes from 'prop-types'

import * as Constants from './constants'

const getShuftiIframeUrl = `
  query ShuftiProIframeUrl($type: ShuftiProDocumentType!) {
    shuftiPro {
      shuftiProIframeUrl(type: $type)
    }
  }
`

const getShuftiDocument = `
  query shuftiProDocument($type: String!){
    shuftiPro {
      shuftiProDocument(type: $type) {
        type
        verified
        pending
        proofs {
          url
          type
          status
          rejectionReason
        }
      }
    }
  }
`

export function Iframe(props) {
  const isRefetch = React.useRef(false)

  const [iframeUrlResponse] = Urql.useQuery({
    query: getShuftiIframeUrl,
    variables: {
      type: props.type,
    },
    requestPolicy: 'cache-and-network',
  })
  const iframeUrl = iframeUrlResponse?.data?.shuftiPro?.shuftiProIframeUrl

  const [documentResponse, fetchDocument] = Urql.useQuery({
    query: getShuftiDocument,
    variables: {
      type: props.type,
    },
    requestPolicy: 'cache-and-network',
  })

  React.useEffect(() => {
    const document = documentResponse?.data?.shuftiPro?.shuftiProDocument

    if (isRefetch.current && typeof document?.verified === 'boolean') {
      if (document.verified) {
        props.onSuccessful()
      } else {
        props.onFailure()
      }
      isRefetch.current = false
    }
  }, [props.onSuccessful, props.onFailure, documentResponse, isRefetch])

  React.useEffect(() => {
    function handleMessage(event) {
      if (event?.data?.type === Constants.IFRAME_CALLBACK_EVENT) {
        fetchDocument()
        isRefetch.current = true
      }
    }
    window.addEventListener('message', handleMessage)
    return () => window.removeEventListener('message', handleMessage)
  }, [])

  if (!iframeUrl) {
    return null
  }

  return (
    <iframe
      className={props.className}
      allow="camera"
      frameBorder="0"
      src={iframeUrl}
      width={props.width}
      height={props.height}
    />
  )
}

Iframe.defaultProps = {
  width: '100%',
  height: '100%',
}

Iframe.propTypes = {
  className: PropTypes.string,
  height: PropTypes.string,
  type: PropTypes.string.isRequired,
  width: PropTypes.string,
  onSuccessful: PropTypes.func.isRequired,
  onFailure: PropTypes.func.isRequired,
}
